import FormInputSelect from './FormInputSelect';

export default FormInputSelect;
